import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-key-features',
  templateUrl: './key-features.component.html',
  styleUrls: ['./key-features.component.css']
})
export class KeyFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
